export default {
  install(Vue) {
    let cachedDeviceId = localStorage.getItem("device_id") || null;

    async function getDeviceId() {
      if (cachedDeviceId) return cachedDeviceId;

      const fp = await import("@fingerprintjs/fingerprintjs");
      const agent = await fp.load();
      const result = await agent.get();
      cachedDeviceId = result.visitorId;

      localStorage.setItem("device_id", cachedDeviceId);
      return cachedDeviceId;
    }

    Vue.prototype.$deviceId = getDeviceId;
  },
};
